import { render, staticRenderFns } from "./TemplateSearch-v2.vue?vue&type=template&id=1deb359c&scoped=true&"
import script from "./TemplateSearch-v2.vue?vue&type=script&lang=js&"
export * from "./TemplateSearch-v2.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSearch-v2.vue?vue&type=style&index=0&id=1deb359c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb359c",
  null
  
)

export default component.exports